import styled from 'styled-components';


export const WrapperCardapio = styled.div`
    display: flex;
    overflow: hidden;
    align-items: center;
    opacity: 0;
    border-bottom: solid 1.2em #2E0011;
    width: 100%;
    height: 100%;

`
export const FotoCardapio = styled.div`
    display: flex;
    width: 60%;


    @media screen and (max-width: 1100px) {
        width: 100%;

    }
`
export const PhotoCardapio = styled.img`
    width: 100%;
    // object-fit: cover;

    @media screen and (max-width: 1000px) {
        opacity: 0.7;
    }
`
export const InfosCardapio = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

    @media screen and (max-width: 950px) {
        position: absolute;
    }
`
export const TitleCardapio = styled.h3`
    font-size: 60px;
    text-transform: uppercase;
    text-align: center;
    max-width: 600px;
    font-weight: normal;
    margin-bottom: 50px;


    @media screen and (max-width: 500px) {
        font-size: 32px;
    }
`
